import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

import isFunction from 'lodash/isFunction';
import debounce from 'lodash/debounce';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import ClientList from './ClientList';
import ClientDetail from './ClientDetail';
import InfoBubble from './InfoBubble';
import HealthsFilter from './HealthsFilter';

import { QsHelper } from '../../../helpers';

import FiltersOnMap from '../FiltersOnMap';

import { renderToString } from 'react-dom/server';

import constants from '../../../constants';
import HereService from '../../../services/Here';

import './ClientListWithMap.css';
import MapWithIcons from '../../../common/components/MapWithIcons';
import HealthsFilterTab from './HealthsFilterTab';
import { carsStore } from '../../../stores';
import { utils } from '../../../helpers';
import { api } from '../../../services';
import { Spin } from 'antd';

const { HERE_API_KEY: API_KEY } = constants;
const mapservice = new HereService(API_KEY);

@withRouter
@inject('translationsStore', 'filterStore', 'noticesStore', 'mapStore')
@observer
export default class ClientListWithMap extends Component {
  constructor(props) {
    super(props);

    this.defaultTabWhenShowDetail = 'focus';

    this.MapRef = React.createRef();
    this.ClientListRef = React.createRef();

    this.debounceFns = {};

    this.highlightZoom = 14;
    this.defaultPageSize = 1;

    this.state = {
      car: undefined,
      addresses: {},
      timestamp: new Date(),
      mapSetViewBounds: true,

      pageSize: this.defaultPageSize,
      currentPage: 1,
      visibleDiagnosticFilters: true,
      eta: undefined,
      isLoadingCarDetails: false
    };

    this.mapBubbleButton = this.props.translationsStore.translate('map.bubble.button');
  }

  componentDidMount = () => {
    //current.wrappedInstance if the component is wrapped by the mobx injector
    if (this.props.showMap) {
      this.MapInstace = this.MapRef.current.wrappedInstance;
    }
    this.ClientListInstance = this.ClientListRef.current.wrappedInstance;

    window.goToCarView = (e, carId) => {
      return api('getCar', carId).then(car => {
        if (car && car.length >= 1) {
          this.setState({ car: car[0] }, () => {
            this.showClientDetail(car[0]);
          });
        }
      });
    };

    if (this.props.clientId !== undefined) {
      window.goToCarView(null,this.props.clientId);
    }

    if (!this.props.showMap && !!this.props.list && this.props.list.length > 0) {
      let car = this.props.list[0];
      window.goToCarView(null,car.id);
    }
  };

  updateLockbeat = (previousimeisWithLockbeat = [], currentimeisWithLockbeat = []) => {
    previousimeisWithLockbeat.forEach(imeiwithlockbeat => {
      // get all the imeis without lockbeat
      const newnoticeidx = currentimeisWithLockbeat.findIndex(newimei => newimei.imei === imeiwithlockbeat.imei);
      if (newnoticeidx === -1) {
        //lockbeat no more present - return to one of the other icons
        const car = this.props.cars.filter(car => !!car.lastPositionPoint).find(car => imeiwithlockbeat.imei === car.imei);
        if (car) {
          this.MapInstace.getMap().setMarkerIcon(car.id, this.getMarkerMapperIcons(car));
        }
      }
    });
  };

  componentDidUpdate = prevProps => {
    if (prevProps.loading !== this.props.loading && this.props.loading === false) {
      if (this.props.clientId) {
        this.reverseGeocode({ id: this.props.clientId }).then(carAddress => {
          this.setState({ carAddress });
        });
        this.reverseGeocodeAdditionalAddresses(this.state.car).then(additionalCarAddresses => {
          this.setState({ additionalCarAddresses });
        })
        this.ClientListInstance.select({ id: this.props.clientId });
      }
    }
  };

  componentWillUnmount() {
    window.goToCarView = undefined;
  }

  onMouseEnter = car => {
    const debounceFn = debounce(() => {
      if (!!car.lastPositionPoint) {
        this.ClientListInstance.highlight(car);
        if (this.props.showMap) {
          if (this.state.selectedCar) {
            this.MapInstace.highlightMarker(this.state.selectedCar, false);
            clearTimeout(this.state.selectedCarTimeout);
          }
          this.reverseGeocodeAndWrite(car);

          const eta = { time: undefined, distance: undefined };
          if (this.props.mapStore.areaSearching) {
            const [lng, lat] = car.lastPositionPoint.coordinates;
            const toLatLng = this.MapInstace.getMap().getCenter();
            mapservice
              .routeSummary({ fromLatLng: { lat, lng }, toLatLng: toLatLng })
              .then(response => {
                eta.time = response.trafficTime;
                eta.distance = response.distance;
              })
              .catch(() => {})
              .finally(() => {
                this.setState({ eta: { ...eta, carId: car.id } });
              });
          } else {
            this.setState({eta: undefined});
          }

          this.MapInstace.showBubble(car);
          if (!this.props.mapStore.areaSearching) {
            this.MapInstace.highlightMarker(car);
            this.MapInstace.center(car, this.highlightZoom);
          }
        }
      }
    }, 300);
    this.debounceFns[car.id] = debounceFn;
    debounceFn();
  };

  onMouseLeave = car => {
    if (isFunction(this.debounceFns[car.id])) {
      this.debounceFns[car.id].cancel();
    }
  };

  onClick = car => {
    // Add loading state before API call
    this.setState({ isLoadingCarDetails: true });

    return api('getCar', car.id).then(car => {
      if (car && car.length >= 1) {
        this.setState({
          car: car[0],
          isLoadingCarDetails: false
        }, () => {
          this.showClientDetail(car[0]);
        });
      }
    }).catch(error => {
      this.setState({ isLoadingCarDetails: false });
      console.error('Error fetching car details:', error);
    });
  };

  showClientDetail = car => {
    const { match, history, location } = this.props;
    this.ClientListInstance.select(car);
    if (car) {
      if (this.props.showMap) {
        this.reverseGeocode(car)
          .then(carAddress => {
            this.setState({ carAddress });
          })
          .catch(error => {
            this.setState({ carAddress: false });
          });

        this.reverseGeocodeAdditionalAddresses(car)
          .then(additionalCarAddresses => {
            this.setState({ additionalCarAddresses });
          })
            .catch(error => {
              this.setState({ additonalCarAddresses: [] });
            });

        history.push(match.path.replace(':carId?', car.id) + location.search);
      } else {
      history.push(match.path.replace(':carId?', car.id));
      }
    } else {
      history.push(match.path.replace('/:carId?', ''));
    }
  };

  getCurrentTab = () => {
    return new QsHelper(this.props.location.search).get('tab') || this.defaultTabWhenShowDetail;
  };

  reverseGeocodeAndWrite = car => {
    this.reverseGeocode(car).then(address => {
      //ISSUE: ci possono essere piu' elementi con lo stesso id. Capita quando le props (filtri) vengono ricaricate
      document.querySelectorAll(`#address-${car.id}`).forEach(elm => {
        elm.innerHTML = address.label;
      });
    });
  };

  /*eslint radix: ["error", "as-needed"]*/
  reverseGeocode = car => {
    const _car = this.props.cars.find(c => parseInt(c.id) === parseInt(car.id)) || {};
    if (_car.lastPositionPoint) {
      const [lng, lat] = _car.lastPositionPoint.coordinates;
      return this.MapInstace.whenMapIsReady().then(() => this.MapInstace.getMap().getAddressFromReverseGeocode({ lat, lng }));
    } else {
      return Promise.resolve(false);
    }
  };

  reverseGeocodeAdditionalAddresses = car => {
    if (car && car.additionalPositions) {
      const additionalPositions = []

      return this.MapInstace.whenMapIsReady().then(() => {
        // Reverse geocode additional positions
        const additionalPositionPromises = (car.additionalPositions || []).map(addPos => {
          return this.MapInstace.getMap().getAddressFromReverseGeocode({ lat: addPos.lat, lng: addPos.lon })
              .then(address => additionalPositions.push(address));
        })

        // return promise that wait for all other promises to resolve
        return Promise.all(additionalPositionPromises).then(() => additionalPositions);
      })
    } else {
      return Promise.resolve([]);
    }
  };

  markersMapper = car => {
    const { translationsStore } = this.props;
    const [lng, lat] = car.lastPositionPoint.coordinates;
    let marker = {
      ...car,
      lng,
      lat,
      html() {
        const { getRenderedToReplace } = utils;
        let html = renderToString(<InfoBubble translationsStore={translationsStore} car={car} />);
        const replacement = getRenderedToReplace(html);
        html = html.replace(/data-replace-render="[^"]+"/g, `onclick="window.${replacement.fn}(event, ${replacement.args.join(', ')})"`);
        return html;
      }
    };
    return marker;
  };

  calcWidth = () => {
    if (isString(this.props.listWidth)) {
      return `calc(100% - ${this.props.listWidth})`;
    }
    if (isNumber(this.props.listWidth)) {
      return `${100 - this.props.listWidth}%`;
    }
    return '100%';
  };

  onGroupChange = groupId => {
    this.showClientDetail();
    this.props.onGroupChange(groupId);
  };

  onFilterTabClick = () => {
    this.setState({ visibleDiagnosticFilters: !this.state.visibleDiagnosticFilters }, () => {
      window.dispatchEvent(new Event('resize'));
    });
  };

  onPageListChange = (page, pageSize) => {
    this.props.onPageListChange(page, pageSize);
  }

  onToggleFilter = (name, reload = true) => {
    this.props.onToggleFilter(name, reload);
  }

  onRemoveFilter = (name) => {
    this.props.onRemoveFilter(name);
  }

  onApplyFilter = () => {
    this.props.onApplyFilter();
  }

  onSearchOnMap = (lat, lng, distance) => {
    this.props.onSearchOnMap(lat, lng, distance);
  }

  onCancelSearchOnMap = () => {
    this.props.onCancelSearchOnMap();
  }

  render() {
    const simpleMapCars = this.props.cars.map(car => Object.assign({}, {id: car.id, plate: car.plate}));
    return (
      <div className="ClientListWithMap">
        <div style={{ width: `${this.props.listWidth}`, display: 'flex' }}>
          <ClientList
            ref={this.ClientListRef}
            clientId={this.props.clientId}
            width={`100%`}
            loading={this.props.loading}
            cars={(this.props.list || []).filter(car => car.hidden !== true).sort((a,b) => {
              if (!this.state.distanceFn) return 0;
              if (!(a.lastPositionPoint && a.lastPositionPoint.coordinates && b.lastPositionPoint && b.lastPositionPoint.coordinates)) return 0;
              const [Alng, Alat] = a.lastPositionPoint.coordinates;
              const [Blng, Blat] = b.lastPositionPoint.coordinates;
              return this.state.distanceFn(Alng, Alat) < this.state.distanceFn(Blng, Blat) ? -1 : 1
            })}
            carsCount={this.props.carsCount}
            page={this.props.page}
            pageSize={this.props.pageSize}
            groups={(this.props.groups || [])}
            onClick={this.onClick}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            onGroupChange={this.onGroupChange}
            notices={this.props.noticesStore.unreadNotices}
            currentPage={1}
            onPageListChange={this.onPageListChange}
            simpleMapCars={simpleMapCars}
            showMap={this.props.showMap}
          />
        </div>
        {this.state.isLoadingCarDetails ?
         (<div className='ClientDetail' style={{ width: this.calcWidth(), zIndex: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
            <Spin spinning={this.state.isLoadingCarDetails} tip={this.props.translationsStore.translate('spin.loading')}
            size='large'/>
          </div>)
         : (
        <div>
          <ClientDetail
            style={{
              width: this.calcWidth(),
              zIndex: `${!!this.props.clientId ? 10 : 0}`,
              display: `${!!this.props.clientId ? 'block' : 'none'}`
            }}
            car={this.state.car}
            carAddress={this.state.carAddress}
            additionalCarAddresses={this.state.additionalCarAddresses}
            back={() => this.showClientDetail()}
            currentTab={this.getCurrentTab()}
          />
          {(this.props.showMap &&
            <div style={{ width: this.calcWidth() }} className="map-and-filter">
              <HealthsFilterTab visibleFilters={this.state.visibleDiagnosticFilters} onTabClick={this.onFilterTabClick} />
              <HealthsFilter visibleFilters={this.state.visibleDiagnosticFilters} carsFilters={this.props.carsFilters} filters={this.props.filters} onToggleFilter={this.onToggleFilter} style={{ width: '100%', zIndex: 1 }} />
              <FiltersOnMap visibleFilters={this.state.visibleDiagnosticFilters} carsFilters={this.props.carsFilters} filters={this.props.filters} onToggleFilter={this.onToggleFilter} onRemoveFilter={this.onRemoveFilter} onApplyFilter={this.onApplyFilter} />
              <MapWithIcons
                notices={this.props.cars.filter(car => (car.hasNotifications))}
                imeisWithNotices={this.props.cars.filter(car => (car.hasNotifications))}
                imeisWithLockbeat={this.props.imeisWithLockbeat}
                withLocationSearch={true}
                loading={this.props.loading}
                ref={this.MapRef}
                onTap={({ data, event }) => {
                  if (!this.props.mapStore.areaSearching) {
                    if ((data || {}).source === 'places') {
                      this.MapInstace.center(data);
                    } else {
                      this.MapInstace.center(data, this.highlightZoom);
                    }

                    this.setState({eta: undefined});
                  } else {
                    const eta = { time: undefined, distance: undefined };
                    const [lng, lat] = data.lastPositionPoint.coordinates;
                    const toLatLng = this.MapInstace.getMap().getCenter();
                    mapservice
                      .routeSummary({ fromLatLng: { lat, lng }, toLatLng: toLatLng })
                      .then(response => {
                        eta.time = response.trafficTime;
                        eta.distance = response.distance;
                      })
                      .catch(() => {})
                      .finally(() => {
                        this.setState({ eta: { ...eta, carId: data.id } });
                      });
                  }
                  this.reverseGeocodeAndWrite(data);
                  event.preventDefault();
                }}
                onMapDragDebounced={() => {
                  const { mapStore } = this.props;
                  if (this.props.mapStore.areaSearching) {
                    const { openedMarker } = mapStore;
                    if (openedMarker) {
                      const car = openedMarker.getData();
                      const [lng, lat] = car.lastPositionPoint.coordinates;
                      const eta = { time: undefined, distance: undefined };
                      const toLatLng = this.MapInstace.getMap().getCenter();
                      mapservice
                        .routeSummary({ fromLatLng: { lat, lng }, toLatLng })
                        .then(response => {
                          eta.time = response.trafficTime;
                          eta.distance = response.distance;
                        })
                        .catch(() => {})
                        .finally(() => {
                          this.setState({ eta: { ...eta, carId: car.id } });
                        });
                    }
                  }
                }}
                eta={this.state.eta}
                setViewBounds={this.state.mapSetViewBounds}
                markerId="plate"
                className={`clientsListMap ${this.state.visibleDiagnosticFilters ? 'filtersOpen' : 'filtersClosed'}`}
                markers={this.props.cars}
                markersFilter={car => !!car.lastPositionPoint}
                markersMapper={this.markersMapper}
                getLat={car => car.lastPositionPoint.coordinates[1]}
                getLng={car => car.lastPositionPoint.coordinates[0]}
                onSearchOnMap={({ lat, lng, radius, contains, distance }) => {
                  const filterFn = car => {
                    if (car.lastPositionPoint) {
                      const [lng, lat] = car.lastPositionPoint.coordinates;
                      if (contains(lng, lat)) {
                        return true;
                      }
                    }
                    return false;
                  };
                  this.setState({ mapSetViewBounds: false, distanceFn: distance });
                  this.onSearchOnMap(lat, lng, radius);
                }}
                onCancelSearch={() => {
                  this.setState({ mapSetViewBounds: true, distanceFn: undefined });
                  this.onCancelSearchOnMap();
                }}
              />
            </div>
          )}
        </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientListWithMap.js